interface IUpdateEmailPayload {
    email: string;
}

export const getStateToPayload = (email: string): IUpdateEmailPayload => ({ email });
